import React, { useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { IoMdAddCircleOutline } from "react-icons/io";

const Accordion = (props) => {
  const { data = [], text } = props;
  const columnsData = ["Ээлж", "Цаг", "Анги", "Хичээл", "Анги танхим"];
  const [isVisible, setIsVisible] = useState(false);
  return (
    <div
      className="border-neutral-200 dark:border-neutral-600 dark:bg-neutral-800 cursor-pointer select-none rounded-t-lg border"
      onClick={() => {
        setIsVisible(!isVisible);
      }}
    >
      <h2
        className={`${
          isVisible ? "border-neutral-200 border-b " : ""
        } mb-0 flex items-center justify-between py-4 px-8`}
        id="headingOne"
      >
        <p className={`text-neutral-800 dark:bg-neutral-800 text-lg font-bold`}>
          {text}
        </p>

        {isVisible ? (
          <IoCloseCircleOutline className="h-8 w-8 text-activeOrange dark:text-white" />
        ) : (
          <IoMdAddCircleOutline className="h-8 w-8 text-activeOrange dark:text-white" />
        )}
      </h2>

      <div id="collapseOne" className={isVisible ? "block" : "hidden"}>
        <div className="px-4 py-4">
          <table
            className="responsive_table"
          >
            <thead>
              <tr key={"tsch-header"}>
                {columnsData.map((column, index) => (
                  <th
                    key={"user-header" + index}
                  >
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((row, i) => {
                return (
                  <tr key={i}>
                    <td data-label="Ээлж">{row.shift.name ?? row.shift}</td>
                    <td data-label="Цаг">{row.time}</td>
                    <td data-label="Анги">{row.course}</td>
                    <td data-label="Хичээл">{row.lesson}</td>
                    <td data-label="Анги танхим">
                      {row.classroom.number}-{row.classroom.building}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
